module.exports = __webpack_public_path__ + "static/media/canDefault.b6a9274a.png";